import { ChannelTypes } from 'types';
import { CreateNewProfilesEntity } from '../types/CreateNewProfiles.type';

export const CREATE_NEW_PROFILES_EMPTY_PROFILE_ENTITY: CreateNewProfilesEntity = {
  artistName: null,
  channelUrls: [],
  gender: null,
  locations: [],
  email: null
};

type FeatureSupportedChannelsOnly = Exclude<
  ChannelTypes,
  'blog' | 'facebook' | 'pinterest' | 'snapchat' | 'tumblr' | 'twitter'
>

/**
 * At first it looks weird, because it is.
 * But I wanted to have a distionary which will cause compile error when it doesn't reflect
 * correctly all values of updated ChannelTypes type.
 */
export const AVAILABLE_CHANNELS_DICTIONARY: { [ch in FeatureSupportedChannelsOnly]: null } = {
  instagram: null,
  tiktok: null,
  youtube: null
};
